import "./App.css";
import ScrollToTop from "./utilities/functions/ScrollToTop";
import { Suspense, } from "react";
import { ClipLoader } from "react-spinners";
import { Box, Center } from "@chakra-ui/react";
import { useAuth } from "./context/AuthContext";
import AdminRoutes from "./routes/AdminRoutes";
import NoAuthRoutes from "./routes/NoAuthRoutes";
import SuperAdminRoutes from "./routes/SuperAdminRoutes";
import DeliveryRoutes from "./routes/DevlieryRoutes";
import StoreKeeperRoutes from "./routes/StoreKeeperRoutes";

function App() {
  const { token, checked, role } = useAuth();

  let routes;
  if (token) {
    if (role === "delivery") {
      routes = <DeliveryRoutes />;
    } else if (role === "storeKeeper") {
      routes = <StoreKeeperRoutes />;
    } else if (role === "superadmin") {
      routes = <SuperAdminRoutes />;
    } else if (role === "admin") {
      routes = <AdminRoutes />;
    }
  } else {
    routes = <NoAuthRoutes />;
  }

  return (
    <Box bgColor={"#F7FAFC"} minH='100vh'>
      <ScrollToTop />
      <Box minW='96vw'>
        <Suspense
          fallback={
            <Center alignSelf={"center"} minH="90vh">
              <ClipLoader size={45} color="#22BBE6" />
            </Center>
          }
        >
          {checked ?
            routes
            :
            <Center minH='90vh'>
              <ClipLoader size={45} color='#22BBE6' />
            </Center>
          }
        </Suspense>

      </Box>
    </Box>
  );
}

export default App;
